// import Geocode from "react-geocode";

// export const getLonAndLat = (address) => {
//   Geocode.setApiKey("AIzaSyCc1m4igtojL1Lw6ytce0qr8cAE4aI4iMk");
//   const answer = Geocode.fromAddress(address).then(
//     (response) => {
//       const { lat, lng } = response.results[0].geometry.location;
//       return {
//         latitude: lat,
//         longitude: lng
//       }
//     },
//     (error) => {
//       console.error(error);
//     }
//   );

//   return answer
// }

export const getLonAndLat = async (address, { timeoutMs = 20000 } = {}) => {
  const addr = (address ?? "").trim();
  if (!addr) throw new Error("Address is required");

  const url = "https://driveportal.cityrelaysolutions.com:443/public/getLonAndLatByAddress";
  const controller = new AbortController();
  const timeoutId = setTimeout(() => controller.abort("timeout"), timeoutMs);

  try {
    console.log(`[geocode] requesting coords for "${addr}"…`);
    const res = await fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ address: addr }),
      signal: controller.signal,
    });

    console.log(`[geocode] response status: ${res.status} ${res.statusText}`);

    // Read the raw text even on error so we can debug the backend
    const rawText = await res.text().catch(() => "");

    // Try to parse JSON if possible
    let data;
    try {
      data = JSON.parse(rawText);
    } catch {
      data = {};
    }

    // Backend/service error: non-2xx or unexpected API response
    if (!res.ok) {
      console.error("[geocode] server returned error:", rawText);
      throw new Error(`Server error ${res.status}: ${data?.message || res.statusText}`);
    }

    if (data?.statusCode !== 200 || data?.statusError !== "SUCCESS") {
      console.error("[geocode] API-level error:", data);
      throw new Error(data?.message || "Geocoding failed at API level");
    }

    const latitude = Number(data?.map?.latitude);
    const longitude = Number(data?.map?.longitude);

    if (!Number.isFinite(latitude) || !Number.isFinite(longitude)) {
      console.error("[geocode] invalid coordinates in response:", data);
      throw new Error("Invalid coordinates in response");
    }

    console.log(`[geocode] received coords: lat=${latitude}, lng=${longitude}`);
    return { latitude, longitude };
  } catch (err) {
    if (err.name === "AbortError" || (typeof err.message === "string" && err.message.toLowerCase().includes("timeout"))) {
      console.warn("[geocode] request timed out or was aborted");
      const e = new Error("Geocoding timed out on the backend. Please try again.");
      e.code = "TIMEOUT";
      throw e;
    }
    console.error("[geocode] fetch/network error:", err);
    throw err;
  } finally {
    clearTimeout(timeoutId);
  }
};